import React, { useContext } from 'react'
import AuthService from '../services/auth.service'

const AuthContext = React.createContext<Partial<AuthService>>({
  isAuthenticated: () => false
})

export const AuthConsumer = AuthContext.Consumer

export const useAuth = () => useContext(AuthContext)

export default AuthContext
